import * as Sentry from '@sentry/nextjs'

export type NotifySentryOpts<CaughtErrorType = unknown> = {
  caughtError?: CaughtErrorType
  metadata?: Record<string, unknown>
  groupingHash?: string
  // Optional severity override for captureMessage
  level?: Sentry.SeverityLevel
}

export function notifySentry<CaughtErrorType = unknown>(
  errorMessage: string,
  opts?: NotifySentryOpts<CaughtErrorType>
): string | undefined {
  const {caughtError, metadata, groupingHash, level} = opts || {}
  let eventId: string | undefined
  Sentry.withScope(scope => {
    // Persist freeform message alongside exceptions for context
    if (errorMessage) {
      scope.setContext('message', {errorMessage})
    }
    if (caughtError) {
      scope.setTag(
        'error_type',
        (caughtError as unknown as object)?.constructor?.name
      )
      scope.setContext('caught_error', {
        error: caughtError,
      })
    }

    if (metadata) {
      scope.setContext('custom_metadata', metadata)
    }

    if (groupingHash) {
      scope.setFingerprint(['{{ default }}', groupingHash])
    }

    if (caughtError) {
      eventId = Sentry.captureException(caughtError)
    } else {
      eventId = Sentry.captureMessage(errorMessage, level ?? 'error')
    }
  })
  return eventId
}
